<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        {{ disabledDate?.title }}
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="row disabled-date-row">
                        <div class="col-md-4 m-b-sm"><b>Status</b></div>
                        <div class="col-md-8 m-b-sm">
                            <span class="label label-declined">Disabled</span>
                        </div>

                        <div class="col-md-4 m-b-sm"><b>Date from</b></div>
                        <div class="col-md-8 m-b-sm">
                            {{ disabledDate?.start | date : 'dd.MM.yyyy' }}
                        </div>

                        <div class="col-md-4 m-b-sm"><b>Date to</b></div>
                        <div class="col-md-8 m-b-sm">
                            {{ disabledDate?.end | date : 'dd.MM.yyyy' }}
                        </div>

                        <div class="col-md-4 m-b-xs">
                            <b>Note</b>
                        </div>
                        <div class="col-md-8 m-b-xs">
                            <span class="clickable mtv-primary-color" (click)="addNote()" *ngIf="!disabledDate?.note">
                                <i class="fa fa-plus"></i> <span class="bold">Add</span>
                            </span>
                        </div>
                        <div class="col-md-12 m-b-sm" style="white-space: pre-line;" *ngIf="disabledDate?.note">
                            {{ disabledDate?.note }}
                        </div>
                    </div>

                    <div class="row disabled-date-row" *ngIf="showAddNoteForm">
                        <div class="col-md-12 m-b-sm">
                            <textarea
                                class="form-control"
                                [(ngModel)]="newNote"
                                [disabled]="savingNote"
                                name="note"
                                maxlength="255"
                                placeholder="Type note"
                            >
                                </textarea>
                            <span class="text-muted">{{ newNote.length }}/255</span>
                        </div>
                        <div class="col-xs-4"></div>
                        <div class="col-xs-8 display-inline">
                            <div class="row">
                                <div class="col-xs-6">
                                    <button
                                        class="btn btn-primary btn-block"
                                        (click)="saveNote()"
                                        [disabled]="savingNote"
                                        type="button">
                                        Save Note
                                    </button>
                                </div>
                                <div class="col-xs-6 text-right">
                                    <button
                                        class="btn btn-outline-primary btn-block"
                                        (click)="$event.preventDefault(); cancelNote()"
                                        type="button"
                                        [disabled]="savingNote"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-backdrop fade in" (click)="hideModal()"></div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/disabled-date-modal/disabled-date-modal.component.html